import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer/activity'
// Modules
import activity from './activity'

const initialState = () => ({
    activities: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        activities: state => state.activities.data,
        pagination: state => state.activities.pagination
    },
    actions: {
        /**
         * @param {{customerId: number, params: {}}} data
         * @returns {Promise<*>}
         */
        listActivities: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listActivities(data)
                const activities = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_ACTIVITIES, activities)
                return activities
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetActivities: ({commit}) => commit(mutationTypes.RESET_ACTIVITIES)
    },
    modules: {
        activity
    },
    mutations: {
        [mutationTypes.RESET_ACTIVITIES]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_ACTIVITIES]: (state, data) => state.activities = data
    }
}
